<div class="card card-profile ">
  <div class="profile">
    <div class="company-action-list debt-width">
      <div class="company-row">
        <div class="left">
          <div class="icon-container">
            <i class="bg-red icon ic-debt-20"></i>
          </div>

          <div class="text-container">
            <div class="money">{{ companyProfile.companyDebt?.amountOwing | currency : "$" : 'code' : '1.2-2' }}</div>
            <div class="title">
              Company Debt
              <app-tooltip
                iconClass="icon ic-info-circle-16 ml-2"
                [tooltipText]="'Last updated on ' + (debtUpdatedDate | date: 'dd/MM/yyyy HH:mm')"
              />
            </div>
          </div>
        </div>

        <div class="right">
          <div ngbDropdown [placement]="['bottom-end', 'bottom-start', 'top-start', 'top-end']">
            <button
              ngbDropdownToggle
              class="btn btn-secondary btn-icon"
              [disabled]="disableControls"
            >
              <i class="icon ic-more-horizontal-20"></i>
            </button>

            <div
              ngbDropdownMenu
              aria-labelledby="company-actions-dd"
              class="common-dropdown-menu dropdown-menu dropdown-menu-right"
            >
              @for (item of companyDebtMenu; track $index) {
                @if(!item.isVisable){
                  <button
                    ngbDropdownItem
                    [disabled]="item.disabled ?? false"
                    (click)="item.action()"
                  >
                    <i class="{{item.iconClass}}"></i>
                    <span>{{ item.title }}</span>
                  </button>
                }
              }
            </div>
          </div>
        </div>
      </div>

      <div class="company-row">
        <div class="left align-items-center cursor-pointer" (click)="openDocumentsTab()">
          <div class="icon-container">
            <i class="icon ic-form-pending-20 bg-orange"></i>
          </div>

          <div class="text-container">
            <div class="count">{{ countPendingForm }}</div>
            <div class="title">Pending Forms</div>
          </div>
        </div>
      </div>

      <div hidden>
        <app-auto-pay
          [entityId]="companyProfile.entityId"
          [entityName]="companyProfile.name"
        />
      </div>
    </div>

    <app-divider/>

    <div class="company-action-list">
      <div class="company-row">
        <div class="left">
          <img src="../../../../assets/images/asic-logo.png" alt="img" class="img-max36">
          <div class="text-container">
            <div class="text">ASIC</div>
            <div class="sub-text">Synced {{ companyProfile.refreshedOn | dateAgo }}</div>
          </div>
        </div>

        <div class="right">
          <button
            class="btn btn-secondary btn-icon"
            [disabled]="disableControls"
            (click)="triggerRA71()"
          >
            <i class="icon ic-refresh-20"></i>
          </button>
        </div>
      </div>

      @if (showXpm) {
        <app-xpm-card-profile
          [(externalEntities)]="companyProfile.externalEntities"
          [entityId]="companyProfile.entityId"
          [entityNumber]="companyProfile.entityNumber"
          [disableControls]="disableControls"
          (onEntityRefreshed)="onCompanyRefreshedEvent()"
          [entityType]="entityType"
        />
      }
    </div>
  </div>
</div>
